import Icon from "@ant-design/icons"
import { ReactComponent as EnglandFlag } from "./uk.svg"

const UkFlagIcon = (props: any) => <Icon component={EnglandFlag} {...props} />

export default UkFlagIcon
